import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogRoutingModule } from './catalog-routing.module';
import { OverviewModule } from './overview/overview.module';

// Direct path imports (not barrel '@htx/catalog'): see Ticket 5 — barrel-induced TDZ silently loses module imports.
@NgModule({
  imports: [CommonModule, CatalogRoutingModule, OverviewModule],
  providers: []
})
export class CatalogModule {}
